import { MULTISELECT_FILTER_TYPE, RANGE_FILTER_TYPE, BUCKET_FILTER_TYPE } from './enums';

export enum ProductWizardFlowType {
  MULTIPLE = 'multiple',
  LINEAR = 'linear',
}

export enum ProductWizardInputType {
  CHECKBOX = 'checkbox',
  RADIO = 'radio',
}

export type ProductWizardIntro = {
  title: string;
  subTitle?: string;
  buttonLabel: string;
};

export type ProductWizardAnswer = {
  title: string;
  appliedFilters?: Array<string>;
  min?: number;
  max?: number;
  subTitle?: string;
  imagePath?: string;

  productCount?: number;
  selected?: boolean;
};

export type ProductWizardFlowAnswer = {
  id: string;
  title: string;
  subTitle?: string;
  imagePath?: string;
  categoryFilter: string;
  categoryUrl: string;

  productCount?: number;
  selected?: boolean;
};

export type ProductWizardQuestion = {
  title: string;
  filter: string;
  filterType?: MULTISELECT_FILTER_TYPE | RANGE_FILTER_TYPE | BUCKET_FILTER_TYPE;
  inputType: ProductWizardInputType;
  nextButtonLabel?: string;
  skipButtonLabel?: string;
  subTitle?: string;
  answers: Array<ProductWizardAnswer>;

  dataLoaded?: boolean;
};

export type ProductWizardFlowQuestion = {
  title: string;
  nextButtonLabel?: string;
  nonActiveStatLabel?: string;
  subTitle?: string;
  answers: Array<ProductWizardFlowAnswer>;

  dataLoaded?: boolean;
};

export type ProductWizardFlow = {
  id: string;
  categoryFilter: string;
  categoryUrl: string;
  questions: Array<ProductWizardQuestion>;
};

export type ProductWizardData = {
  flows: Array<ProductWizardFlow>;
  intro: ProductWizardIntro;
  question?: ProductWizardFlowQuestion;
  type: ProductWizardFlowType;
};
